import blueGrayRedGradient from './three-point/blue-gray-red';
import blueYellowRedGradient from './three-point/blue-yellow-red';
import orangeBlueGreenGradient from './three-point/orange-blue-green';
import orangeGrayBlueGradient from './three-point/orange-gray-blue';
import orangeVioletBlueGradient from './three-point/orange-violet-blue';
import pinkGrayGreenGradient from './three-point/pink-gray-green';
import redOrangeGreenGradient from './three-point/red-orange-green';
import trafficLightGradient from './three-point/traffic-light';
import violetBlueGreenGradient from './three-point/violet-blue-green';
import yellowGreenBlueGradient from './three-point/yellow-green-blue';

export const THREE_POINT_GRADIENTS = {
    [blueGrayRedGradient.id]: blueGrayRedGradient,
    [blueYellowRedGradient.id]: blueYellowRedGradient,
    [orangeBlueGreenGradient.id]: orangeBlueGreenGradient,
    [orangeGrayBlueGradient.id]: orangeGrayBlueGradient,
    [orangeVioletBlueGradient.id]: orangeVioletBlueGradient,
    [pinkGrayGreenGradient.id]: pinkGrayGreenGradient,
    [redOrangeGreenGradient.id]: redOrangeGreenGradient,
    [violetBlueGreenGradient.id]: violetBlueGreenGradient,
    [yellowGreenBlueGradient.id]: yellowGreenBlueGradient,
    [trafficLightGradient.id]: trafficLightGradient,
};

export const THREE_POINT_GRADIENT_PALETTES = {
    blueGrayRedGradient,
    blueYellowRedGradient,
    orangeGrayBlueGradient,
    orangeBlueGreenGradient,
    orangeVioletBlueGradient,
    pinkGrayGreenGradient,
    redOrangeGreenGradient,
    violetBlueGreenGradient,
    yellowGreenBlueGradient,
    trafficLightGradient,
};
